import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-VideoPlayShape",
  "use": "svg-icon-VideoPlayShape-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"svg-icon-VideoPlayShape\"><path d=\"M0 18.002c0 9.94 8.062 17.997 17.997 17.997 9.947 0 18.007-8.057 18.007-17.997C36.004 8.059 27.944 0 17.997 0 8.062 0 0 8.059 0 18.002zm13.68-6.848a1.195 1.195 0 0 1 1.844-1.003L26.04 17a1.199 1.199 0 0 1 0 2.003l-10.516 6.85c-.366.236-.837.25-1.218.046a1.192 1.192 0 0 1-.626-1.052V11.154z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol